// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"sY-z","tooltip":"tY-z","tooltipContent":"uY-z","orderStatusWrapper":"vY-z"};